/**
 * GoldRule — single-pixel champagne-gold hairline divider.
 * Replaces the legacy `.gold-rule` utility with a proper component.
 *
 * @example
 *   <GoldRule />
 *   <GoldRule width="6rem" align="center" />
 *   <GoldRule weight={2} tone="foil" />
 */
import React from "react";

const TONE = {
  base: "var(--gold-base)",
  foil: "var(--gold-foil)",
  soft: "var(--gold-soft)",
  deep: "var(--gold-deep)",
};

const ALIGN = {
  left:   "mr-auto",
  center: "mx-auto",
  right:  "ml-auto",
};

export default function GoldRule({
  width = "3rem",
  weight = 1,
  tone = "base",
  align = "left",
  className = "",
  ...rest
}) {
  const color = TONE[tone] || TONE.base;
  return (
    <span
      role="presentation"
      aria-hidden="true"
      className={`block ${ALIGN[align] || ALIGN.left} ${className}`}
      style={{ width, height: `${weight}px`, backgroundColor: color }}
      {...rest}
    />
  );
}
